import { useRef, useState } from "react";

const useFileInput = (name, validType) => {

    const divInput = useRef();
    const [value, setValue] = useState('');
    const [isTouched, setIsTouched] = useState(false);
    const ALLOWED_EXTENSIONS = ['pdf', 'jpg', 'jpeg'];
    
    validType = validType.split(",");

    let isValid = (typeof value !== 'undefined' && value.length > 0 && validType.includes(value[0].type)) || (typeof name !== 'undefined' && name.trim() !== "" );
    
    if(typeof value !== 'undefined' && value.length > 0){
        const extension = value[0].name.split('.').pop().toLowerCase();
        isValid = ALLOWED_EXTENSIONS.includes(extension)
    }

    let fileName = "";
    let messageFile = "";
    if(isValid){
        if(typeof value !== 'undefined' && value.length > 0){
            fileName = value[0].name;
        } else if(typeof name !== 'undefined' && name.trim() !== ""){
            fileName = name;
        }
    }else{
        if(typeof value !== 'undefined' && value.length > 0 && value[0].type !== validType){
            messageFile = "El formato del archivo debe ser válido"
        }else{
            messageFile = "Campo obligatorio"
        }
    }

    const valueChangeHandler = (event) => {
        setValue(event.target.files);
    }

    const inputBlurHandler = () => {
        setIsTouched(true);
    }

    const resetInput = () => {
        setValue('');
        setIsTouched(false);
    }

    const headerOffset = 56; // Tamaño del header en px
    const scrollToDiv = () => {
        let pos = divInput.current.getBoundingClientRect().top;
        let offset = pos + window.pageYOffset - headerOffset - parseInt(window.innerHeight/10);

        window.scrollTo({
            top: offset,
            behavior: "smooth"
        });
    }

    return {
        value,
        fileName,
        isValid,
        isTouched,
        divInput,
        messageFile,
        valueChangeHandler,
        inputBlurHandler,
        resetInput,
        scrollToDiv
    };
};

export default useFileInput;